export const loadingShow = () => {
  return { type: "LOADING_SHOW" };
};

export const LoadingHide = () => {
  return { type: "LOADING_HIDE" };
};
